module.exports = __webpack_public_path__ + "static/tis-6febbe4cdd7ca41429bc934fc7f3e874.jpg";